export { CollectionProxy } from "./collection-proxy";
export { RecordProxy } from "./record-proxy";
export { NullProxy } from "./null-proxy";